import { JSX } from 'react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import { KibModal } from '@chewy/kib-overlays-react';

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css';
import '@chewy/kib-overlays-styles/dist/styles/kib-modal.css';
import '@chewy/kib-transition-styles/dist/kib-transition.css';
import '@src/components/login-redirect-modal/index.scss';

export const LoginRedirectModal = ({
  open,
  onOpen,
  onClose,
  onContinue,
}: {
  open: boolean;
  onOpen: VoidFunction;
  onClose: VoidFunction;
  onContinue: VoidFunction;
}): JSX.Element => (
  <KibModal
    title="Please sign in again."
    id="hcpi-login-expired-modal"
    data-testid="login-redirect-modal"
    open={open}
    onOpen={onOpen}
    onClose={onClose}
    controls={() => (
      <>
        <KibButtonNew
          emphasis="secondary"
          data-testid="closeButton"
          onClick={onClose}
        >
          Close
        </KibButtonNew>
        <KibButtonNew onClick={onContinue}>Sign in</KibButtonNew>
      </>
    )}
  >
    <p>
      For your security, you have been signed out. Please sign in again to
      continue.
    </p>
  </KibModal>
);
